
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { UploadFileType } from '@/enums';
import { UploadFileResponse } from '@/api/typing';
import { Api } from '@/util/api';
import { ActionUtils } from '@/util/action';

@Component({})
export default class UploadFileInputV2 extends Vue {
  @Prop({ type: String, required: true })
  type!: UploadFileType;

  @Prop({ type: Array, required: true, default: () => [] })
  files: UploadFileResponse[] = [];

  // image/png, image/jpeg
  @Prop({ type: String, required: false })
  acceptedFiles?: string;

  @Prop({ type: String, required: false })
  tip?: string;

  @Prop({ type: Boolean, required: false, default: false })
  multiple?: boolean;

  @Prop({ type: String, required: false, default: 'picture-card' })
  listType?: 'picture-card' | 'text' | 'picture';

  @Prop({ type: Number, required: false })
  limit?: number;

  @Prop({ type: String, required: false })
  exceedTip?: string;

  uploadTaget = {
    data: {
      key: '',
      token: '',
    },
    url: '',
    file: {},
  };

  @Emit('update:files')
  onUploadFiles(res: any, file: File, files: UploadFileResponse[]) {
    Object.assign(file, {
      response: {
        file: this.uploadTaget.file,
      },
    });
    return files;
  }

  get uploadFileHeaders() {
    return {
      Token: localStorage.getItem('token'),
    };
  }

  @Emit('update:files')
  onRemoveFile(file: File, files: UploadFileResponse[]) {
    this.files = [...files];
    return this.files;
  }

  onExceedFiles() {
    this.$message.error(this.exceedTip || `最多只允许上传${this.limit}个文件`);
  }

  onPreviewFile(file: UploadFileResponse) {
    ActionUtils.open(file.url);
  }

  async beforeUpload(file: File) {
    try {
      const response = await Api.current.coreApi.getUploadFileTokenUsingPOST({
        type: this.type,
        contentType: file.type,
        originalFilename: file.name,
      });
      this.$set(this.uploadTaget.data, 'token', response.data.uploadToken);
      this.$set(this.uploadTaget.data, 'key', response.data.uploadedFile!.key);
      this.$set(this.uploadTaget, 'url', response.data.uploadUrl);
      this.$set(this.uploadTaget, 'file', response.data.uploadedFile);
      return false;
    } catch (error) {
      this.$message.error('Get upload token failed, please try again later.');
      return false;
    }
  }
}
